/** @jsxImportSource @emotion/react */
import type { FC } from 'react';
import { ChevronRight } from 'react-feather';
import {
  connectHitInsights,
  connectHits,
  connectInfiniteHits,
  Highlight,
  Snippet,
} from 'react-instantsearch-dom';
import { Text } from '@algolia/ui-library';
import Image from '../../../../components/image';
import TextLink from '../../../../components/text-link';
import styles from '../../../../css/pages/search.css';
import { isBrowser, setSessionStorageItem } from '../../../../helpers';
import ShowMore from '../show-more';

interface ResourcesHitProps {
  hit: {
    url: string;
    post_title:string;
    permalink: string;
    __queryID: string;
    objectID: string;
    selected_stream: string;
    images: {
      medium: {
        url: string; 
      }
    };
  };
  insights: (event: string, options: any) => void;
  indexName: string;
}

const ResourcesHit: FC<ResourcesHitProps> = ({ hit, insights, indexName }) => (
  
  <li key={hit.permalink}>
  
    <TextLink
      onClick={() =>
        insights('clickedObjectIDsAfterSearch', {
          eventName: 'Clicked resources result',
        })
      }
      className="h-100p d-flex fxd-column jc-between"
      to={`${hit.permalink}/`}
    >
      <div>
      {hit.images && hit.images['medium'] && hit.images['medium']['url'] && (
          <Image
            className="bdw-1 bdc-grey-100 bds-solid w-100p bdr-6 obf-cover bgc-grey-100"
            src={hit.images['medium']['url']}
            alt={hit.post_title}
          />
        )}
        <Text className="mt-16 mb-0">
          <span className="d-block lh-big fw-bold">
            <Highlight hit={hit} attribute="post_title" />
          </span>
        </Text>
        <Text className="mt-8 mb-0 wb-break" small>
          {/* <Highlight hit={hit} attribute="content" /> */}
          <Snippet attribute="content" hit={hit} />
        </Text>
      </div>
    </TextLink>
  </li>
);

const ConnectedResourcesHit = isBrowser
  ? connectHitInsights((window as any).aa)(ResourcesHit)
  : () => null;

export const CustomResourcesInfiniteHits = connectInfiniteHits(
  ({ hits, hasMore, refineNext }) => (
    <>
      <ul className="d-grid gvgap-20 ghgap-48 m-0 p-0 lis-none xs:g-2 sm:g-4">
        {hits.map((hit, index) => (
          <ConnectedResourcesHit key={`${hit.h1}-${index}`} hit={hit} />
        ))}
      </ul>
      <ShowMore hasMore={hasMore} refine={refineNext} />
    </>
  )
);

export const CustomResourcesHits = connectHits(({ hits }) => (
  <>
    <ul className="d-grid gvgap-20 ghgap-48 m-0 p-0 lis-none xs:g-2 sm:g-4">
      {hits.map((hit, index) => (
        <ConnectedResourcesHit key={index} hit={hit} />
      ))}
    </ul>
  </>
));
